import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { addZgloszeniePodZezwolenie } from "@/service/weexpertService";
import { toast } from "@/components/ui/use-toast";
import { NIEPODJECIE, ZGLOSZENIE_DO_ZEZWOLENIA } from "@/constants";
import { useQueryClient } from "react-query";
import { InputWithAlert } from "@/components/ui/input-with-alert";
import { BaseDialog } from "../dialog";
import { DatePicker } from "@/components/ui/date-picker";
import { format, isAfter } from "date-fns";

export default function UploadZgloszeniePodZezwoleniePopup({
  clientId,
  zezwolenieId,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState();
  const queryClient = useQueryClient();

  const [date, setDate] = useState(new Date());

  const [inputChecked, setInputChecked] = useState(false);
  const [isButtonBlocked, setIsButtonBlocked] = useState(false);
  const handleUpload = () => {
    setInputChecked(true);
    if (!files) {
      toast({
        title: "Please upload a file before submitting.",
        variant: "destructive",
      });
      return;
    }
    setIsButtonBlocked(true);

    toast({
      title: "Starting uploading",
    });
    const res = addZgloszeniePodZezwolenie(
      zezwolenieId,
      files,
      clientId,
      null,
      ZGLOSZENIE_DO_ZEZWOLENIA,
      null,
      null,
      {
        zezwolenie: zezwolenieId,
        date: format(date, "yyyy-MM-dd"),
      },
    )
      .then(() => {
        toast({
          title: "Success",
        });
      })
      .catch(() => {
        toast({
          title: "Error",
          variant: "destructive",
        });
      })
      .finally(() => {
        queryClient.invalidateQueries(["client_documents"]);
        setOpen(false);
        setIsButtonBlocked(false);
      });
  };

  return (
    <BaseDialog
      dialogTitle={""}
      buttonText={t("common:button_upload") + "ZGLOSZENIE"}
      open={open}
      setOpen={setOpen}
    >
      <div className="w-[400px] p-1">
        <div className="w-full pt-4">
          <DatePicker
            date={date}
            defaultMonth={date}
            setDate={(e) => setDate(e)}
            error={inputChecked && (!date || isAfter(date, new Date()))}
            errorMessage={t("empty_data_invalid")}
            label={t("invoices:date_of_creation_from")}
          />
        </div>
        <div className="w-full flex justify-between pt-4">
          <div>
            <input
              ref={fileInputRef}
              accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.png,.jpg"
              multiple
              onChange={(e) => {
                setFiles(e.target.files);
              }}
              type="file"
              className="block text-sm text-gray-500 file:mr-4 file:py-2 file:px-4
                           file:rounded-sm file:border-0 file:text-sm file:font-semibold
                           file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex justify-end pt-4">
        <Button disabled={isButtonBlocked} onClick={handleUpload}>
          {t("common:button_upload")} "Zgloszenie"
        </Button>
      </div>
    </BaseDialog>
  );
}
